export enum DragAndDropZone {
    SIDEBAR = 'SIDEBAR',
    TIMESLOT = 'TIMESLOT'
}

export enum DragItem {
    SCHEDULE_CARD = 'SCHEDULE_CARD'
}
